import {translations} from './TranslationKey'

export function isTranslationKey(key: unknown): key is TranslationKey {
  return typeof key === 'string' && key in translations
}

export type Translations = typeof translations

type StripPluralSuffix<K> = K extends `${infer Base}_one` | `${infer Base}_other` ? Base : K
export type TranslationKey = StripPluralSuffix<keyof Translations>

type ValuesForKey<K extends string> =
  | (K extends keyof Translations ? Translations[K] : never)
  | (`${K}_one` extends keyof Translations ? Translations[`${K}_one`] : never)
  | (`${K}_other` extends keyof Translations ? Translations[`${K}_other`] : never)

type ExtractParamName<P extends string> = P extends `${infer Name},${string}` ? Name : P
type ExtractParams<T> = T extends `${string}{{${infer Param}}}${infer Rest}`
  ? ExtractParamName<Param> | ExtractParams<Rest>
  : never

type RecordOrNever<K extends string, V> = [K] extends [never] ? never : Record<K, V>

export type TranslationStringParamMap = {
  [K in TranslationKey]: RecordOrNever<ExtractParams<ValuesForKey<K>>, string | number>
}

export type TranslationOptions<K extends TranslationKey> = TranslationStringParamMap[K] & {
  interpolation?: {escapeValue: boolean}
  formatParams?: Record<string, Intl.DateTimeFormatOptions | Intl.NumberFormatOptions>
}
